export default {
    url: '',
    template: `
        <div class="loader02" ng-if="!vm.course"></div>
        <courses-courses-edit-general
            course="vm.course"
            fields="vm.fields"
            sites="vm.sites"
            certificates="vm.certificates"
            can-manage-course="vm.canManageCourse"
        />
    `,
    resolve: {
        course (CourseResource, CourseService, $stateParams) {
            return CourseResource.get({ id: $stateParams.id,
                expand: 'fields,courseTrainings,courseTrainings.scormTrainings,courseTrainings.materials' +
                    ',courseTrainings.materials.languages,courseTrainings.materials.chapters.chapterI18ns' +
                    ',courseTrainings.materials.chapters.section.sectionI18ns,activeI18n,courseI18ns,courseTrainingI18ns,' +
                    'courseVersions,courseTrainingForms,sites,userCertificates,owner'
            }).$promise.then((course) => {
                CourseService.nestCompositeModels(course);
                return course;
            });
        },
        sites (SiteResource) {
            return SiteResource.query({ courseManageSites: true, pageSize: 0 }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        },
        certificates (CompanyResource) {
            return CompanyResource.certificates({ expand: 'activeI18n' }).$promise;
        }
    },
    controller ($rootScope, $scope, lodash, course, classifiers, sites, certificates, CourseService, CLASSIFIER_ENUM) {
        $scope.$parent.vm.step = 1;
        $scope.$parent.vm.course = course;
        $scope.$parent.vm.isArchived = course.isArchived;
        this.course = angular.copy(course);
        this.canManageCourse = CourseService.canManageCourse(course);
        this.sites = sites;
        this.certificates = certificates;
        // we delete the following key because it is not needed for general tab
        delete this.course.courseVersions;
        this.fields = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.FIELD);
        lodash.forEach(this.fields, (field) => {
            field.activeI18nValue = field.activeI18n.value;
        });

        $scope.$on('archiveChange', (event, { isArchived }) => {
            $scope.$parent.vm.isArchived = isArchived;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/general/index.js